import { useAppSelector } from '@/stores';
import Speech from '../../Svg/Speech';
import { SpeechPauseSvg } from '../../Svg';
import style from './index.module.less';

export default function Analysis(props: any) {
  const {playStatus, playIndex} = useAppSelector(state => state.listening);
  const {index} = props;
  
  return <span {...props} className={style.speechBox} data-disable={true}>{
    playIndex === index && playStatus === 'pause' ? SpeechPauseSvg({className: style.speechSvg}) :
      Speech({className: `${style.speechSvg} ${playIndex === index && playStatus === 'play' ? style.soundPlaying : ''}`})
  }</span>;
}